module.exports = __webpack_public_path__ + "static/media/icons.e3c53ac5.svg";